import s from './AboutUs.module.css'

const AboutUs = () => {
  return (
    <div id={'about-us'} className={s.privatPolicy}>
      <h2 className={s.subTitle}>Про нас</h2>
      <p className={s.text}>
        <span>Style Solution</span> – це ваш шлях у світ стилю. Ми спеціалізуємося на створенні інноваційних рішень для
        індустрії краси, використовуючи передові технології та дизайнерські підходи. Наша команда експертів поєднує
        пристрасть до стилю з глибоким розумінням потреб сучасних клієнтів. <b>Ми пропонуємо:</b>
        <br />
        <br />
        <span>Індивідуальні рішення для бізнесу.</span> <br /> Наші послуги включають розробку та впровадження
        інноваційних рішень для барбершопів, салонів краси та перукарень. Ми допомагаємо автоматизувати процеси і
        покращити якість обслуговування клієнтів.
        <br />
        <br />
        <span>Сучасні технології.</span> Ми використовуємо штучний інтелект та передові веб-технології для створення
        функціональних і стильних веб-ресурсів, які відповідають найвищим стандартам.
        <br />
        <br />
        <span>Клієнтський підхід.</span> У нашому підході акцент на індивідуальний підхід до кожного клієнта. Ми уважно
        вислуховуємо ваші потреби і пропонуємо рішення, які допоможуть вам досягти успіху у вашій сфері.
        <br /> <br />
        <span>Підтримка та розвиток.</span> Ми не просто створюємо рішення, ми підтримуємо і розвиваємо їх разом з вами.
        Наші фахівці завжди готові надати допомогу і запропонувати нові ідеї для вашого бізнесу.
        <br />
        <br />
        <span>Style Solution</span> – ваш ключ до успішного розвитку у світі краси та стилю.
      </p>
    </div>
  )
}

export default AboutUs
